const formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'ka yar il bidhiqsi',
    other: 'ka yar {{count}} il bidhiqsiyo',
  },

  xSeconds: {
    one: '1 il bidhiqsi',
    other: '{{count}} il bidhiqsiyo',
  },

  halfAMinute: 'nus daqiiqad',

  lessThanXMinutes: {
    one: 'ka yar hal daqiiqo',
    other: 'ka yar {{count}} daqiiqadood',
  },

  xMinutes: {
    one: '1 daqiiqo',
    other: '{{count}} daqiiqadood',
  },

  aboutXHours: {
    one: 'ilaa 1 saac',
    other: 'ilaa {{count}} saacadood',
  },

  xHours: {
    one: '1 saac',
    other: 'ilaa {{count}} saacadood',
  },

  xDays: {
    one: '1 maalin',
    other: 'ilaa {{count}} maalmood',
  },

  aboutXMonths: {
    one: 'ilaa 1 bil',
    other: 'ilaa {{count}} bilood',
  },

  xMonths: {
    one: '1 bil',
    other: '{{count}} sanadood',
  },

  aboutXYears: {
    one: 'ilaa 1 sano',
    other: 'ilaa {{count}} sanadood',
  },

  xYears: {
    one: '1 sano',
    other: '{{count}} sanadood',
  },

  overXYears: {
    one: 'ka badan 1 sano',
    other: 'ka badan {{count}} sanadood',
  },

  almostXYears: {
    one: 'ugu badnaan 1 sano',
    other: 'ugu badnaan {{count}} sanadood',
  },
};

export default function formatDistance(token, count, options) {
  options = options || {};

  let result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'gudaha ' + result;
    }

    return result + ' kahor';
  }

  return result;
}
